import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format cents as a dollar string (e.g., 1234 -> "$12.34")
 */
export function formatCentsAsDollars(cents: number, locale?: string): string {
  return new Intl.NumberFormat(locale || 'en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(cents / 100)
}

/**
 * Generate a random promo code string.
 * Uses a character set that avoids commonly confused characters (0/O, 1/I/L).
 * 
 * @param length Length of the code (default: 8)
 * @returns Random uppercase alphanumeric code
 */
export function generateRandomPromoCode(length: number = 8): string {
  // Exclude confusing characters: 0/O, 1/I/L
  const chars = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789'
  let code = ''
  for (let i = 0; i < length; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return code
}
